export default __webpack_public_path__ + "static/media/default.cac68521.png";